export default {"src":"//tokenlon.im/_next/static/media/mascot-upset.cb9b9cf1.gif","height":200,"width":200};